import { create } from 'zustand';
import { TypeContributePeople } from 'src/features/PeopleDetail/Common/config';

export interface ICompanyContribute {
  open: boolean;
  type: TypeContributePeople | null;
}

export interface IFormSearchAction {
  handleCloseContribute: () => void;
  handleOpenContribute: (type: TypeContributePeople) => void;
}

export const usePeopleContribute = create<ICompanyContribute & IFormSearchAction>((set) => {
  return {
    open: false,
    type: null,
    handleCloseContribute: () => set(() => ({ open: false, type: null })),
    handleOpenContribute: (type: TypeContributePeople) => set(() => ({ open: true, type })),
  };
});
